// @ts-nocheck
import { ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { createHandlerChainRunnerOptionalParameter } from "@toolkit/Modules/client-framework/HandlerCreator";
import { removeCartAllowance } from "@store/Framework/Services/AllowanceService";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {},
    ApiParameter,
    BaseModel,
    {
        errorMessage: string;
    }
>;

export const DispatchBeginRemoveAllowance: HandlerType = props => {
    props.dispatch({
        type: "Pages/CheckoutReviewAndSubmit/BeginRemoveAllowance",
    });
};

export const ValidateCart: HandlerType = props => {
    const state = props.getState();
    const { cartId } = getQueryStrings(state);
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no cart when we were trying to remove a allowance from it.");
    }
};

export const RemoveCartAllowance: HandlerType = async props => {
    const result = await removeCartAllowance();
    if (!result.successful) {
        props.errorMessage = result.errorMessage!;
    }
};

export const LoadCart: HandlerType = props => {
    const state = props.getState();
    const { cartId } = getQueryStrings(state);
    if (cartId) {
        props.dispatch(loadCart({ cartId }));
    } else {
        props.dispatch(loadCurrentCart());
    }
};

export const DispatchCompleteRemoveAllowance: HandlerType = props => {
    props.dispatch({
        type: "Pages/CheckoutReviewAndSubmit/CompleteRemoveAllowance",
        errorMessage: props.errorMessage,
    });
};

export const chain = [
    DispatchBeginRemoveAllowance,
    ValidateCart,
    RemoveCartAllowance,
    LoadCart,
    DispatchCompleteRemoveAllowance,
];

const removeAllowance = createHandlerChainRunnerOptionalParameter(chain, {}, "RemoveAllowance");
export default removeAllowance;
